var _g, _g2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 66,
    viewBox: "0 0 164 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Preview_svg__filter0_ddd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.11,
    y: 5,
    width: 149.781,
    height: 22.308,
    rx: 4.78,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.264 21.82a5.672 5.672 0 01-5.666-5.666 5.672 5.672 0 015.666-5.665 5.672 5.672 0 015.665 5.665 5.672 5.672 0 01-5.665 5.665zm0-9.915a4.254 4.254 0 00-4.25 4.249 4.254 4.254 0 004.25 4.25 4.254 4.254 0 004.249-4.25 4.254 4.254 0 00-4.25-4.25z",
    fill: "#E1E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.93 16.154a5.666 5.666 0 00-5.666-5.665.708.708 0 000 1.416 4.25 4.25 0 014.249 4.249.708.708 0 001.416 0z",
    fill: "url(#Preview_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.214,
    y: 13.681,
    width: 121.896,
    height: 4.947,
    rx: 2.473,
    fill: "url(#Preview_svg__paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Preview_svg__filter1_ddd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.11,
    y: 35.346,
    width: 149.781,
    height: 22.308,
    rx: 4.78,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.264 52.166a5.672 5.672 0 01-5.666-5.666 5.672 5.672 0 015.666-5.665 5.672 5.672 0 015.665 5.665 5.672 5.672 0 01-5.665 5.666zm0-9.915a4.254 4.254 0 00-4.25 4.25 4.254 4.254 0 004.25 4.248 4.254 4.254 0 004.249-4.249 4.254 4.254 0 00-4.25-4.249z",
    fill: "#E1E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.93 46.5a5.666 5.666 0 00-5.666-5.665.708.708 0 000 1.416 4.25 4.25 0 014.249 4.25.708.708 0 001.416 0z",
    fill: "url(#Preview_svg__paint2_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.214,
    y: 44,
    width: 121.896,
    height: 5,
    rx: 2.5,
    fill: "url(#Preview_svg__paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Preview_svg__paint0_linear",
    x1: 14.369,
    y1: 13.675,
    x2: 20.742,
    y2: 20.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BADBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Preview_svg__paint1_linear",
    x1: -30.734,
    y1: 16.154,
    x2: -30.333,
    y2: 26.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BADBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Preview_svg__paint2_linear",
    x1: 14.369,
    y1: 44.022,
    x2: 20.742,
    y2: 50.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BADBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Preview_svg__paint3_linear",
    x1: -30.734,
    y1: 46.5,
    x2: -30.324,
    y2: 56.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BADBC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Preview_svg__filter0_ddd",
    x: 0.736,
    y: 0.22,
    width: 162.528,
    height: 35.055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.187
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.0960719 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.797
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.797
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.147645 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.797,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.419608 0 0 0 0 0.564706 0 0 0 0 0.752941 0 0 0 0.0486779 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Preview_svg__filter1_ddd",
    x: 0.736,
    y: 30.566,
    width: 162.528,
    height: 35.055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.593
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.187
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.0960719 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.797
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.797
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349638 0 0 0 0 0.380478 0 0 0 0 0.407892 0 0 0 0.147645 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.797,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.419608 0 0 0 0 0.564706 0 0 0 0 0.752941 0 0 0 0.0486779 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default ForwardRef;